// import { Router } from "express";
import { createRouter, createWebHistory } from "vue-router";
import store from "./store";

// import pages
import LoginUser from "./components/pages/LoginUser.vue";
import RegisterUser from "./components/pages/RegisterUser.vue";
import HomePage from "./components/pages/HomePage.vue";
import UserProfile from "./components/pages/UserProfile.vue";
import DashBoard from "./components/pages/DashBoard";
import Clients from "./components/pages/clients";
import RegisterEstate from "./components/pages/RegisterEstate";
import RegisterClient from "./components/pages/RegisterClient";
import OutsideClient from "./components/pages/newClients";
import ReceivePayment from "./components/pages/ReceivePayments";
import Payments from "./components/pages/payments";
import MpesaPayments from "./components/pages/mpesaPayments";
import registerapartment from "./components/pages/regsiterapartment.vue";

// import smstoAll from "./components/pages/smstoAll"

import Reports from "./components/pages/reports";

import Estates from "./components/pages/estates";

import estates from "./components/pages/estates";

import ClientPayments from "./components/pages/ClientPayments";
import EstatePayments from "./components/pages/estatePayments";
import estateClients from "./components/pages/estateClients";
import RequestingClients from "./components/pages/requestingClients";
import Messages from "./components/pages/messages";
import simpleSms from "./components/pages/simpleSms";
import smsReport from "./components/pages/smsReport";
import voters from "./components/pages/voters"
import mpesa from "./components/pages/mpesa.vue"
import updatePayment from "./components/pages/updatePayments.vue"


import editClient from "./components/pages/editClient.vue";

// import store from './store'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", component: HomePage },
    { path: "/login", component: LoginUser, meta: { auth: false } },
    { path: "/register", component: RegisterUser, meta: { auth: false } },
    { path: "/profile", component: UserProfile, },
    { path: "/dashboard", component: DashBoard, meta: { auth: true }  },
    { path: "/apps", component: DashBoard, meta: { auth: true }  },

        { path: "/ekerenyo/voters", component: voters },


    
    { path: "/reports", component: Reports, meta: { auth: true }  },
    {
      path: "/register/clients",
      component: RegisterClient,
      meta: { auth: true }
    },
    { path: "/clients", component: Clients, meta: { auth: true } },
    { path: "/register/estate", component: RegisterEstate, meta: { auth: true } },
    {path: "/new/client/registration", component: OutsideClient, meta: { auth: false } },
    { path: "/estates", component: Estates, meta: { auth: true }  },
    { path: "/estates", component: estates, meta: { auth: true }  },
    { path: "/requesting/clients", component: RequestingClients, meta: { auth: true }  },
    { path: "/messages", component: Messages, meta: { auth: true }  },
    { path: "/send/simple/sms", component: simpleSms, meta: { auth: true }  },
    { path: "/sms/report", component: smsReport, meta: { auth: true }  },
    // {path: "/send/sms/all", component:smstoAll, meta: {auth:true}},
    {
      path: "/receive/payment",
      component: ReceivePayment,
      meta: { auth: true }
    },
    { path: "/payments", component: Payments, meta: { auth: true } },
    { path: "/register/apartment", component: registerapartment, meta: { auth: true } },

    { path: "/mpesa/payments", component: MpesaPayments, meta: { auth: true } },
        { path: "/mpesa", component: mpesa, meta: { auth: true } },

    { path: "/client/payments/:client", component: ClientPayments, meta: { auth: true }  },
    { path: "/estate/payments/:estate", component: EstatePayments, meta: { auth: true }  },
    { path: "/estate/clients/:estate", component: estateClients, meta: { auth: true }  },
    { path: "/edit/client/:clientId", component: editClient, meta: { auth: true }  },
        { path: "/mpesa/:payment_reference", component: updatePayment, meta: { auth: true }  },

    // { path: "/edit/client/:clientId", component: editClient },



  ],
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.isLoggedIn) {
      next({ path: '/Login' })
    } else {
      next() // go to wherever I'm going
    }
  } else {
    next() // does not require auth, make sure to always call next()!
  }
})

export default router;
